<template>
  <el-row class="page" :gutter="10">
    <el-col :span="12" class="left">
      <el-row>
        <el-col class="chartBoard">
          <el-col class="filter" :span="24">
            <label>月份选择</label>
            <el-date-picker
                v-model="lineChart.month"
                style="width: 350px"
                type="month"
                @change="getOrderQuantityMonthly"
                placeholder="选择月份">
            </el-date-picker>
          </el-col>
          <el-col>
            <line-chart :series-data="lineChart.seriesData" :title="lineChart.titleMonth"
                        style="height: 310px"></line-chart>
          </el-col>
        </el-col>
        <el-col class="chartBoard">
          <el-col class="filter" :span="24">
            <label>时间范围</label>
            <el-date-picker
                v-model="columnChart.dateRange" type="daterange" unlink-panels :clearable="false" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                @change="getOrderAmountAndSalesChart"
                value-format="timestamp"
                :default-time="['00:00:00', '23:59:59']">>
            </el-date-picker>
          </el-col>
          <el-col :span="24" >
            <column-chart v-if="columnChart.columnShow"
                          :title="columnChart.titleTime + '各病区订单数量排行'" y-axis-name="数量 (件)"
                          :x-axis-array="columnChart.bedRange.total[0]"
                          style="height: 310px"
                          :series-data="columnChart.seriesData[0]"></column-chart>
            <column-chart v-else
                          :title="columnChart.titleTime + '各病区订单销售金额排行'" y-axis-name="金额 (元)"
                          :x-axis-array="columnChart.bedRange.total[1]"
                          style="height: 310px"
                          :series-data="columnChart.seriesData[1]"></column-chart>
          </el-col>
          <el-col class="columnChart1">
            <el-col :span="12" >
              <div class="point pointActive" ref="columnChart1_point0"></div>
              <div class="name nameActive" @click="getOrderCount" ref="columnChart1_name0">订单数量排行</div>
            </el-col>
            <el-col :span="12" style="text-align: left">
              <div class="point" ref="columnChart1_point1"></div>
              <div class="name" @click="getOrderMoney" ref="columnChart1_name1">订单金额排行</div>
            </el-col>
          </el-col>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="12" class="right chartBoard">
      <el-col class="filter" >
        <label>时间范围</label>
        <el-date-picker
            v-model="barChart.dateRange" type="daterange" unlink-panels :clearable="false" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
            @change="getProductSaleAmountChart"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']">>
        </el-date-picker>
      </el-col>
      <el-col class="filter" >
        <label>病区范围</label>
        <el-select
            v-model="barChart.bedRange.selected"
            collapse-tags
            style="width: 350px"
            @change="getProductSaleAmountChart"
            placeholder="请选择病区">
          <el-option
              v-for="(item, index) in barChart.bedRange.total"
              :key="index"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
      </el-col>
      <el-col >
        <bar-chart :title="barChart.titleTime + '销售商品数量排行'" y-axis-name="数量 (件)"
                   :x-axis-array="barChart.xAxisArray" :series-data="barChart.seriesData.series"
                   :count="barChart.seriesData.count"
                   style="height: 676px"
        ></bar-chart>
      </el-col>
    </el-col>
  </el-row>
</template>

<script>
import LineChart from "../../ChartComponents/LineChart";
import ColumnChart from "../../ChartComponents/ColumnChart";
import BarChart from "../../ChartComponents/BarChart";
import GLOBAL from "@/utils/global.js";

export default {
  name: "DataCharts",
  components: {
    LineChart,
    ColumnChart,
    BarChart,
  },
  data() {
    return {
      GLOBAL,
      lineChart: {
        month: new Date().getTime(),
        seriesData: {},
        titleMonth: '',
      },
      columnChart: {
        //x轴的值
        bedRange: {
          total: [
            [], []
          ],
        },
        titleTime: '',
        columnShow: true,
        seriesData: [],
        requestData: {
          startTime: (new Date()).getTime() - 3600 * 1000 * 24 * 7, // 开始日期
          status: "已完成", //订单状态
          endTime: new Date().getTime(), // 结束日期
        },
        dateRange: [(new Date()).getTime() - 3600 * 1000 * 24 * 7, new Date().getTime()],
      },
      barChart: {
        //下拉框的病区
        bedRange: {
          total: [],
          selected: '全部',
        },
        titleTime: '',
        seriesData: {
          series: {},
          count: [],
        },
        xAxisArray: [],
        requestData: {
          startTime: (new Date()).getTime() - 3600 * 1000 * 24 * 7, // 开始日期
          status: "已完成", //订单状态
          endTime: new Date().getTime(), // 结束日期
          page: 1,
          pageSize: 2147483647,
        },
        dateRange: [(new Date()).getTime() - 3600 * 1000 * 24 * 7, new Date().getTime()],
      },
      //日期选择器快捷键
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90 * 4);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // data0: ['07病区', '02病区', '03病区', '04病区', '05病区', '06病区', '08病区', '09病区', '10病区', '11病区',
      //   '12病区', '13病区', '19病区', '15病区', '16病区', '17病区', '输液室', 'ICU病区'],
      // data1: [
      //   {
      //     name: '订单数量占比',
      //     data: [83.6, 78.8, 98.5, 93.4, 96.0, 84.5, 95.0, 94.3, 91.2, 83.5, 96.6, 92.3, 10, 10, 10, 10, 10]
      //   }, {
      //     name: '订单销售金额占比',
      //     data: [42.4, 33.2, 34.5, 39.7, 52.6, 75.5, 57.4, 60.4, 47.6, 39.1, 46.8, 51.1, 10, 10, 10, 10, 10],
      //   }],
      data2: ['商品9000000000000', '商品', '商品', '商品', '商品', '商品', '商品', '商品', '商品', '商品',
        '商品', '商品', '商品', '商品', '商品', '商品', '商品', '商品', '商品', '商品',],
      data3: [
        {
          name: '销售商品数量占比',
          data: [42.4, 33.2, 34.5, 39.7, 52.6, 75.5, 57.4, 60.4, 47.6, 39.1, 46.8, 51.1, 10, 10, 10, 10, 10]
        },
        {
          name: '销售商品数量',
          data: [42.4, 33.2, 34.5, 39.7, 52.6, 75.5, 57.4, 60.4, 47.6, 39.1, 46.8, 51.1, 10, 10, 10, 10, 10],
          visible: false,
        }
      ]
    }
  },
  created() {
    this.getBedInformation();
    this.getOrderQuantityMonthly();
    this.getOrderAmountAndSalesChart();
    this.getProductSaleAmountChart();
  },
  methods: {
    // 选择器change时，触发
    changeData(val) {
      this.barChart.requestData.startTime = val.startTime;
      this.barChart.requestData.endTime = val.endTime;
      if(!this.$store.state.visitorMode && GLOBAL.debugMode){
        console.log(this.barChart.requestData);
      }
    },
    //床位信息
    getBedInformation() {
      this.$store.dispatch('Statistics/getBedInformation')
          .then((res) => {
            // console.log(res);
            this.barChart.bedRange.total = res.data.data['病区号'];
            this.barChart.bedRange.total.unshift('全部');
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    //  折线图，一个月的订单量
    getOrderQuantityMonthly() {
      let month = new Date(this.lineChart.month).getMonth() + 1;
      let year = new Date(this.lineChart.month).getFullYear();
      this.lineChart.titleMonth = year + '年' + month + '月 ';
      this.$store.dispatch("Statistics/getOrderQuantityMonthly", {
        month: month,
        year: year,
      })
          .then((res) => {
            // console.log(res);
            this.lineChart.seriesData = {
              name: month + '月',
              data: res.data.data,
            }
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    //  柱状图
    getOrderAmountAndSalesChart() {
      // console.log(this.columnChart.dateRange, '//////');
      this.columnChart.requestData.startTime = this.columnChart.dateRange[0];
      this.columnChart.requestData.endTime = this.columnChart.dateRange[1];
      this.columnChart.titleTime = this.handleDateFormat(this.columnChart.dateRange[0]) + '至'
          + this.handleDateFormat(this.columnChart.dateRange[1]) + ' ';
      this.$store.dispatch("Statistics/getOrderAmountAndSalesChart", {
        startTime: this.columnChart.requestData.startTime,
        endTime: this.columnChart.requestData.endTime,
      })
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.columnChart.seriesData = [];
            res.data.data.forEach((item, index) => {
              this.columnChart.bedRange.total[index] = item.xAxisCategories;
              this.columnChart.seriesData.push(item.series);
            })
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    getOrderCount(){
      this.columnChart.columnShow = true;
      this.$refs.columnChart1_point0.className = 'point pointActive';
      this.$refs.columnChart1_name0.className = 'name nameActive';
      this.$refs.columnChart1_point1.className = 'point';
      this.$refs.columnChart1_name1.className = 'name';
    },
    getOrderMoney(){
      this.columnChart.columnShow = false;
      this.$refs.columnChart1_point0.className = 'point';
      this.$refs.columnChart1_name0.className = 'name';
      this.$refs.columnChart1_point1.className = 'point pointActive';
      this.$refs.columnChart1_name1.className = 'name nameActive';
    },
  //  条形图
    getProductSaleAmountChart(){
      this.barChart.titleTime = this.barChart.bedRange.selected + ' ' + this.handleDateFormat(this.barChart.dateRange[0]) + '至'
          + this.handleDateFormat(this.barChart.dateRange[1]) + ' ';
      this.barChart.requestData.startTime = this.barChart.dateRange[0];
      this.barChart.requestData.endTime = this.barChart.dateRange[1];
      this.$store.dispatch("Statistics/getProductSaleAmountChart",{
        startTime: this.barChart.requestData.startTime,
        endTime: this.barChart.requestData.endTime,
        district: this.barChart.bedRange.selected,
      })
      .then((res) => {
        if(!this.$store.state.visitorMode && GLOBAL.debugMode){
          console.log(res);
        }
        this.barChart.seriesData.series = res.data.data[0].series;
        this.barChart.seriesData.count = res.data.data[0].count;
        this.barChart.xAxisArray = res.data.data[0].xAxisCategories;
        if(!this.$store.state.visitorMode && GLOBAL.debugMode){
          console.log(this.barChart.seriesData);
        }
        // console.log(this.barChart.xAxisArray);
      })
      .catch((err) => {
        if(!this.$store.state.visitorMode && GLOBAL.debugMode){
          console.log(err);
        }
      })
    },
  //  日期格式转换：时间戳-年月日
    handleDateFormat(timeStamp){
      let time = new Date(timeStamp);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return year + '-' + month + '-' + day;
    }
  },
  watch: {
  },
}
</script>

<style scoped>
.page{
  padding: 10px;
  background-color: rgb(233, 238, 243);
}
.page .right{
  background-color: white;
}
.chartBoard{
  background-color: white;
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 4px;
}
.point{
  margin-right: 6px;
  padding: 0;
  border-radius: 50%;
  background-color: rgb(204, 204, 204);
  width: 12px;
  height: 12px;
  /*border: 1px solid rgb(204, 204, 204);*/
  display: inline-block;
}
.pointActive{
  background-color: rgb(121, 187, 255);
}
.name{
  display: inline-block;
  /*font-size: 12px;*/
  color: rgb(204, 204, 204);
  cursor: pointer;
}
.name:hover{
  color: black;
}
.nameActive{
  color: black;
}
.filter{
  margin-bottom: 1rem;
}
.filter label{
  margin-right: 1rem;
}
</style>
